var v1="<div gnp-common-wrapper-a=\"\"><div id=\"term_main\"><div class=\"term container\"><div class=\"content\"><p></p><h2>{{ ::'_TERM.TITLE' | translate }}</h2><p></p><div ng-bind-html=\"termBody\"></div></div><button type=\"submit\" ng-click=\"accept()\" class=\"btn\">{{ ::'_TERM.ACCEPT_BUTTON' | translate }}</button></div></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/term/show.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/term/show.jade
// module id = 444
// module chunks = 0